import React from 'react';
import { withTranslation } from 'react-i18next';
import GridColumnInputWrapper from '../common/GridColumnInputWrapper';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import ButtonWrapper from '../common/ButtonWrapper';
import { Formik } from 'formik';
import { compose } from 'redux';
import connect from 'react-redux/es/connect/connect';
import { locationsActions } from '../../behavior/locations';
import { initSelectors } from '../../behavior/init';
import { Grid } from 'semantic-ui-react';
import {InputWrapper } from 'react-lib/dist/components-es';
import useUser from '@behavior/init/getUserV2';

const BImportantInformationContainer = ({ ...props }) => {
  const { user } = useUser();

  const [editMode, setEditMode] = React.useState(false);

  const submitHandle = (values, actions) => {
    if (!editMode) {
      setEditMode(true);
      return;
    }
    setEditMode(false);
    const { save } = props;
    save(manipulateValuesBeforeSubmission(values));
    actions.setSubmitting(false);
  };

  const handleCancel = () => {
    setEditMode(false);
  };

  const manipulateValuesBeforeSubmission = values => {
    const { id, importantInformation } = values;
    let saveRequestDto = { id, importantInformation };
    return saveRequestDto;
  };

  const getContainerBody = () => {
    const { values } = props;
    const canModifyImportantInfo =
      initSelectors.isFireBrigade(user) ||
      initSelectors.isChemicalSafetyExpert(user) ||
      initSelectors.isEnvironmentalExpert(user);

    return (
      <Formik
        initialValues={values.location}
        onSubmit={submitHandle}
        onReset={handleCancel}
        render={formikProps => (
          <Grid stackable columns={1}>
            <GridColumnInputWrapper
              {...formikProps}
              value={formikProps.initialValues.importantInformation || ''}
              name="importantInformation"
              disabled={!editMode}
              render={props => <InputWrapper type="textArea" {...props} />}
            />
            {canModifyImportantInfo &&
              (editMode ? (
                <div className="building-flex-buttons">
                  <GridColumnInputWrapper
                    fieldClassName="importantInformationButtons"
                    {...formikProps}
                    render={() => (
                      <ButtonWrapper
                        id="importantInformationUpdateButton"
                        label="details.page.update.button"
                        primary
                        className="mini inputWiderButton right floated"
                        onClick={formikProps.handleSubmit}
                      />
                    )}
                  />
                  <GridColumnInputWrapper
                    fieldClassName="importantInformationButtons"
                    {...formikProps}
                    render={() => (
                      <ButtonWrapper
                        id="importantInformationCancelButton"
                        label="details.page.cancel.button"
                        color="red"
                        className="mini inputWiderButton right floated"
                        onClick={formikProps.handleReset}
                      />
                    )}
                  />
                </div>
              ) : (
                <GridColumnInputWrapper
                  fieldClassName="importantInformationButtons"
                  {...formikProps}
                  render={() => (
                    <ButtonWrapper
                      id="importantInformationUpdateButton"
                      label="details.page.edit.button"
                      primary
                      icon="edit"
                      className="mini inputWiderButton right floated"
                      onClick={formikProps.handleSubmit}
                    />
                  )}
                />
              ))}
          </Grid>
        )}
      />
    );
  };

  return (
    <AccordionWrapper
      {...props}
      closable={false}
      accordionTitle="building.summary.page.important.information.container.title"
      tooltip="building.summary.page.important.information.container.important.info.tooltip"
      render={getContainerBody}
      className="containerReducedWhiteSpace"
    />
  );
};

const mapStateToProps = (state, ownProps) => ({
  ...state.locations,
});

const mapDispatchToProps = dispatch => ({
  save: saveDto => dispatch(locationsActions.saveLocation(saveDto)),
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(BImportantInformationContainer);
